module.exports = __webpack_public_path__ + "img/holly-berry.1855c8ae.svg";